module.exports = new __parcel__URL__("mid-tom_10.6a403e17.mp3").toString();